<template>
    <div class="grid">
        <div>
            <WizardMenu :active-step="activeStep" :is-edit-page="isEditPage" />
        </div>
        <div>
            <div class="flex-wrapper">
                <header class="create-asset-header">
                    <i class="create-asset-header__icon">
                        <!-- <SvgSpriteIcon :key="icon" :icon="icon" /> -->
                    </i>
                    <div class="create-asset-header__content">
                        <h4>{{ header.subHeading }}</h4>
                        <h2>{{ header.heading }}</h2>
                        <p v-html="header.text"></p>
                    </div>
                </header>
                <div
                    class="create-asset"
                    :class="{ 'asset-item': activeStep === 'finish' }"
                ><KeepAlive>

                    <component
                        :is="activeStep"
                        v-if="steps[activeStep]"
                        :asset="getAsset"
                        :is-new="isNew"
                        v-bind="steps[activeStep].props"
                        @change="steps[activeStep].onChange"
                    ></component>
                    </KeepAlive>
                </div>
                <footer
                    v-if="footer"
                    id="create-asset-footer"
                    :class="
                        activeStep === 'binaryFileAndThumb' && !btnDisplay
                            ? 'create-asset-footer-next'
                            : 'create-asset-footer'
                    "
                >
                    <button
                        :class="
                            activeStep === 'binaryFileAndThumb' && !btnDisplay
                                ? 'display-none'
                                : 'create-asset-footer__next button button--with-icon return active'
                        "
                        @click="prevStep"
                    >
                        <i class="icon-next">
                            <NextIcon fill="#0a294a" width="25" />
                        </i>
                        <span class="return-text">{{ footer.prevText }}</span>
                    </button>
                    <div v-if="steps[activeStep]" class="save-or-next-button">
                        <button
                            v-if="footer.nextText"
                            :class="{
                                'create-asset-footer__next button button--with-icon': true,
                                active: isNextActive && !processing && stepValid,
                                inactive:
                                    !isNextActive || processing || !stepValid,
                            }"
                            @click.prevent="
                                isNextActive
                                    ? nextStep(
                                          activeStep === 'finish'
                                              ? true
                                              : false,
                                          hidden
                                      )
                                    : null
                            "
                        >
                            <span>{{
                                processing ? 'processing...' : footer.nextText
                            }}</span>

                            <i
                                v-show="activeStep !== 'finish'"
                                class="icon-next"
                            >
                                <NextIcon fill="#0a294a" width="25" />
                            </i>

                            <i
                                v-show="activeStep === 'finish'"
                                class="icon-finish"
                            >
                                <TickIcon width="50" height="50" />
                            </i>
                        </button>
                        &nbsp;
                        <a
                            v-if="showSaveToDraftButton"
                            :class="{
                                'just-save-link': true,
                                inactive:
                                    !isNextActive || processing || !stepValid,
                            }"
                            @click.prevent="saveToDraft"
                        >
                            Save to draft
                        </a>
                    </div>

                    <span v-if="errorMsg" class="create-asset-footer__msg">{{
                        errorMsg
                    }}</span>
                </footer>

                <YesNoDialog ref="yesNoDialog" />
            </div>
        </div>
    </div>
</template>

<script>
import CreateOrEditAssetMixin from '../mixins/CreateOrEditAssetMixin';
import AssetFileAndThumbnailData from '../components/assetCreate/AssetFileAndThumbnailData.vue';
import AssetMetaData from '../components/assetCreate/AssetMetaData.vue';
import AssetScreenshots from '../components/assetCreate/ScreenshotsAndVideos.vue';
import WizardMenu from '../components/assetCreate/WizardMenu.vue';
import AssetDetailWidget from '@/components/asset_detail/AssetDetailWidget.vue';
import YesNoDialog from '../components/common/modal/ConfirmationDialog.vue';
import EventBus from '../EventBus';
import store from '../store';
import {
    addErrorNotification,
    addSuccesNotification,
    addInfoNotification,
} from '@/lib/notifications';
import API_ERRORS from '@bistudio/api-errors';
import {
    ASSET_DETAIL_PAGE_NAME,
    DASHBOARD_PAGE_NAME,
} from './../router/pageNameConstants';
import AssetsResource from './../services/assets';
//SVGs
import ReturnIcon from 'Svgs/return_arrow.svg?inline';
import NextIcon from 'Svgs/view_all_arrow.svg?inline';
import TickIcon from 'Svgs/tick.svg?inline';

export default {
    components: {
        metaData: AssetMetaData,
        binaryFileAndThumb: AssetFileAndThumbnailData,
        screenshots: AssetScreenshots,
        finish: AssetDetailWidget,
        YesNoDialog,
        WizardMenu,
        ReturnIcon,
        NextIcon,
        TickIcon,
    },
    props: {
        btnDisplay: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            prevBtn: false,
            steps: {
                binaryFileAndThumb: {
                    nextStep: 'metaData',
                    prevStep: null,
                    header: {
                        heading: 'Choose Files',
                        subHeading: 'Upload Thumbnail',
                        text:
                            'Select your files and drag them into your browser window. One file per upload.',
                        icon: 'upload-files',
                    },
                    props: {
                        listeners: {
                            change: this.onThumbnailChanged,
                            // update: this.assetRefresh,
                        },
                    },
                    footer: {
                        nextText: 'Next step',
                        prevText: 'Previous step',
                    },
                },
                metaData: {
                    prevStep: 'binaryFileAndThumb',
                    nextStep: 'screenshots',
                    header: {
                        heading: 'Basic creation info',
                        subHeading: 'Creation details',
                        text:
                            'The more info you give, the better for the upload. Start with a Title, Description and add tags',
                        icon: 'upload-info',
                    },
                    props: {
                        listeners: {
                            change: this.onMetaChanged,
                        },
                    },
                    onChange: this.onMonetizedActionsChange,
                    footer: {
                        nextText: 'Next step',
                        prevText: 'Previous step',
                    },
                },
                screenshots: {
                    nextStep: 'finish',
                    prevStep: 'metaData',
                    header: {
                        heading: 'Screenshots and videos',
                        subHeading: 'Upload Creations',
                        text:
                            'Select your files and drag them into your browser window. One file per upload.',
                        icon: 'upload-screenshots',
                    },
                    props: {
                        listeners: {
                            change: this.onMediaChanged,
                        },
                    },
                    footer: {
                        nextText: 'Next step',
                        prevText: 'Previous step',
                    },
                },
                finish: {
                    //no next step
                    prevStep: 'screenshots',
                    header: {
                        heading: 'Save your work',
                        subHeading: 'Finish upload',
                        // eslint-disable-next-line max-len
                        text:
                            'We need you to review your files and screenshot. Please read carefully the information you just provided and click "Save", you\'ll get a final screen with publishing details',
                        icon: 'upload-finish',
                    },
                    props: {
                        'slider-with-thumbs': true,
                        prePublish: true,
                    },
                    footer: {
                        nextText: 'Publish',
                        prevText: 'Previous step',
                    },
                },
            },
            showSaveToDraftButton: false,
            action: null,
            activeStep: 'binaryFileAndThumb',
            errorMsg: null,
            isNextActive: false,
            processing: false,
            hidden: false,
            tmpAsset: {
                name: '',
                tags: [],
                description: '',
                changelog: '',
                media: [],
                mediaToDelete: [],
                protected: null,
                hidden: false,
                thumbnail: {},
            },
            asset: {},
            loading: false,
            finish: false,
            protected: null,
        };
    },
    computed: {
        activeStepData() {
            if (this.activeStep) {
                return this.steps[this.activeStep];
            }
            return null;
        },
        header() {
            if (this.activeStepData) {
                return this.activeStepData.header;
            }
            return null;
        },
        footer() {
            if (this.activeStep) {
                return this.activeStepData.footer;
            }
            return null;
        },
        isNew() {
            //computed only once - during startup!
            return this.$route.params.id === undefined;
        },
        activeStepQuery() {
            return this.$route.query.step;
        },
        isEditPage() {
            return !!this.$route.params.id;
        },
        stepValid() {
            return (
                !this.errors ||
                !this.errors.items ||
                this.errors.items.length === 0
            );
        },
        getAsset() {
            if (this.activeStep === 'finish') {
                return this.tmpAsset;
            }
            return this.asset;
        }
    },
    watch: {
        'asset.published': {
            handler() {
                this.evaluateSection();
            },
            deep: true,
        },
        activeStep(val) {
            this.$nextTick(() => {
                EventBus.$emit('onActiveStepChange', this.header);
            });
            this.$router.push({ query: { step: val } });
        },
        activeStepQuery(step) {
            // This code handling navigation by return/next native browser buttons
            if (this.activeStep !== step) {
                this.setActiveStep(step);
            }
        },
    },
    async created() {
        await this.onComponentInitOrChange();
        //retrieve state on refresh
        let btnDisplay = JSON.parse(localStorage.btnDisplay || this.btnDisplay);
        this.btnDisplay = btnDisplay;

        if (this.$route.params.btnDisplay) {
            this.btnDisplay = this.$route.params.btnDisplay;
            this.prevBtn = true;
            //save state on refresh
            btnDisplay = this.btnDisplay;
            localStorage.btnDisplay = JSON.stringify(btnDisplay);
        }

        if (this.asset) {
            this.protected = this.asset.protected;
        }
        this.evaluateSection();
    },
    destroyed() {
        this.toggleUnloadDialog(false);
    },
    mixins: [CreateOrEditAssetMixin],
    methods: {
        evaluateSection() {
             if (this.activeStep === 'finish' && this.tmpAsset && !this.tmpAsset.published) {
                    this.showSaveToDraftButton = true;
            } else {
                this.showSaveToDraftButton = false;
            }
        },
        saveAsset(data) {
            return AssetsResource.save(data);
        },
        updateAssetService(asset) {
            asset.protected = this.protected;
            return AssetsResource.patch(this.tmpAsset.id, asset);
        },
        updateScreenshot(data) {
            return AssetsResource.updateScreenshot(this.tmpAsset.id, data);
        },
        updateThumbnail(data) {
            return AssetsResource.updateThumbnail(this.tmpAsset.id, data);
        },
        onPageRedirect(redirectHome) {
            this.redirect(redirectHome);
        },
        processError(err) {
            console.error('There was error when uploading', err, err.stack);
            // eslint-disable-next-line max-len
            if (
                err.response &&
                err.response.data &&
                err.response.data.apiCode === 'storageApiService.uploadError'
            ) {
                let errors = [];
                for (let i = 0; i < err.response.data.data.length; i++) {
                    if (err.response.data.data[i].error) {
                        // eslint-disable-next-line max-len
                        errors.push(
                            'file ' +
                                err.response.data.data[i].file.file_info
                                    .filename +
                                ': ' +
                                err.response.data.data[i].error.message
                        );
                    }
                }
                this.errorMsg = errors.join(', ');
            } else {
                if (
                    err.apiCode ===
                    API_ERRORS.STORAGE_SERVICE.USER_EXCEEDED_FILE_NUMBER_LIMIT
                ) {
                    this.errorMsg = 'Maximum files count limit exceeded';
                    addErrorNotification(this.errorMsg);
                }
                if (
                    err.apiCode ===
                    API_ERRORS.STORAGE_SERVICE.USER_EXCEEDED_SPACE_QUOTA_LIMIT
                ) {
                    this.errorMsg = 'Storage space limit exceeded';
                    addErrorNotification(this.errorMsg);
                }
                if (err.apiCode === 'ylandsApiService.wrongType') {
                    this.errorMsg = 'New version should be the same type.';
                    addErrorNotification(this.errorMsg);
                } else if (err.apiCode === 'ylandsApiService.wrongGuid') {
                    this.errorMsg = 'New version should have the same GUID';
                    addErrorNotification(this.errorMsg);
                } else if (
                    err.apiCode === 'ylandsApiService.assetExistsSameGuid'
                ) {
                    this.errorMsg = 'Asset already exists in workshop.';
                    addErrorNotification(this.errorMsg);
                } else if (
                    err.apiCode === 'ylandsApiService.assetExistsSameName'
                ) {
                    this.errorMsg =
                        'Asset with same name already exists in workshop.';
                    addErrorNotification(this.errorMsg);
                } else if (
                    err.apiCode ===
                    'ylandsApiService.assetWithSameVersionAlreadyExists'
                ) {
                    this.errorMsg = 'This version has been already uploaded.';
                    addErrorNotification(this.errorMsg);
                } else if (err.apiCode === 'validationFailure') {
                    this.errorMsg =
                        'Some values are not valid. Please check your submit form.';
                    addErrorNotification(this.errorMsg);
                } else if (
                    err.response &&
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                ) {
                    this.errorMsg = err.response.data.message;
                    addErrorNotification(this.errorMsg);
                } else {
                    this.errorMsg = err.message;
                    addErrorNotification(this.errorMsg);
                }
            }
        },
        stepChange(newStep, backwards) {
           this.errorMsg = '';
           this.activeStep = newStep;
        },
        async saveToDraft() {
            if (!this.isNextActive) return;


            try {
                
                if (this.activeStep === 'finish') {
                    this.processing = true;
                    await this.updateAsset({publish: false});
                    return;
                }
                this.setActiveStep(this.activeStepData.nextStep);
            } catch (err) {
                this.processError(err);
            } finally {
                this.processing = false;
            }
        },
        async nextStep(publish, hidden) {
            
            try {
                
                if (this.activeStep === 'finish') {
                    this.processing = true;
                    await this.updateAsset({ publish, hidden });
                    return;
                }
                this.setActiveStep(this.activeStepData.nextStep);
            } catch (err) {
                this.processError(err);
            } finally {
                this.processing = false;
            }
        },
        prevStep() {
            if (this.prevBtn) {
                this.btnDisplay = true;
            }
            if (!this.activeStepData.prevStep) {
                this.errorMsg = null;
                this.onPageRedirect(this.isNew);
                return;
            }
            this.setActiveStep(this.activeStepData.prevStep, true);
            this.isNextActive = true;
        },
   

        async binaryFileAndThumbSave() {
            return await AssetsResource.get(this.tmpAsset.id);
        },
   
        async screenshotSave() {
            return await AssetsResource.get(this.tmpAsset.id);
        },
     
        async updateAsset({ publish = false, hidden = false }) {
            let data = {
                ...(publish ? { published: publish } : {}),
                hidden,
                tags: this.tmpAsset.tags,
                changelog: this.tmpAsset.changelog,
                videos: this.tmpAsset.media.filter(
                    (media) => media?.data?.type === 'video'
                ),
            };
           
            if (this.tmpAsset.thumbnail && this.tmpAsset.thumbnail.data?.formData) {
                await this.updateThumbnail(this.tmpAsset.thumbnail.data.formData)
                .catch(err => {
                    this.processError(err);
                });
            }
            // let uploadPromises = [];
            // if (this.tmpAsset.media.length > 0) {
            //     const mediaToUpload = []
            //     this.tmpAsset.media.forEach(mediaItem => {
            //         if (mediaItem.status === 'init' && mediaItem.data?.formData) {
            //             mediaToUpload.push(mediaItem)
            //             uploadPromises.push(this.updateScreenshot(mediaItem.data.formData))
            //         }
            //     });
            // }

            const imagesFormData = new FormData();
            let uploadImgCount = 0;
            this.tmpAsset.media.filter(mediaItem => mediaItem.status === 'init' && mediaItem.data?.formData)
                .forEach((mediaItemm, mediaIndex) => {
                    const fileItem = mediaItemm.data.formData.get('file');
                    imagesFormData.append(`file_${mediaIndex}`, fileItem);
                    uploadImgCount += 1;
                })
            
            const deleteMediaPromises = [];
            if (this.tmpAsset.mediaToDelete.length > 0) {
                this.tmpAsset.mediaToDelete.forEach(mediaItem => {
                    if (!mediaItem?.screenshot?.file_id) return
                    const deletePromise = AssetsResource.removeScreenshot(
                        this.tmpAsset.id,
                        mediaItem.screenshot.file_id
                    );
                    deleteMediaPromises.push(deletePromise)
                })
            }

            const allDeleteRes = await Promise.all(deleteMediaPromises)
            // const uploadRes = await Promise.all(uploadPromises)
            if (uploadImgCount > 0) {
                await this.updateScreenshot(imagesFormData);
            }


            return this.updateAssetService(data).then(() => {
                this.redirect();
                addSuccesNotification('Creation saved successfully');
            });
        },
        
        onMonetizedActionsChange({ isProtected, valid }) {
            this.isNextActive = valid;
            this.protected = isProtected;
        },
      
        async onMediaChanged(data) {
            const { media, mediaToDelete } = data;
            this.$set(this.tmpAsset, 'media', media);
            this.$set(this.tmpAsset, 'mediaToDelete', mediaToDelete);
            this.isNextActive = data.valid;
        },
        onThumbnailChanged(change) {
            this.$delete(this.tmpAsset, 'manifest');
            this.$delete(this.tmpAsset, 'files');

            if (change.thumbnail) {
                this.$set(this.tmpAsset, 'thumbnail', change.thumbnail);
            } else {
                this.$set(this.tmpAsset, 'thumbnail', this.tmpAsset.thumbnail);
            }
        },
         onMetaChanged(data) {
            this.isNextActive = data.valid;
            this.$set(this.tmpAsset, 'tags', data.tags);
            this.$set(this.tmpAsset, 'protected', data.protected);
            this.tmpAsset.tags.splice(data.tags.length);
            this.tmpAsset.changelog = data.changelog;
        },
        redirect(redirectHome) {
            this.finish = true; // for disabling navigation guard
            if (redirectHome) {
                this.$router.replace({ name: DASHBOARD_PAGE_NAME });
            } else {
                this.$router.replace({
                    name: ASSET_DETAIL_PAGE_NAME,
                    params: { id: this.tmpAsset.id },
                });
            }
        },
        async loadAsset(id) {
            try {
                let response = await AssetsResource.get(id);
                return response.data;
            } catch (e) {
                console.error('Unable to load asset', e);
                return;
            } finally {
                this.loading = false;
            }
        },
        setActiveStep(step) {
            if (step !== this.activeStep) {
                this.activeStep = step;
                this.evaluateSection();
            }
        },
        toggleUnloadDialog(add) {
            if (add) {
                window.addEventListener(
                    'beforeunload',
                    this.toggleUnloadDialogCallback
                );
            } else {
                window.removeEventListener(
                    'beforeunload',
                    this.toggleUnloadDialogCallback
                );
            }
        },
        // callback supposed to be a separate method for removeEventListener
        toggleUnloadDialogCallback(e) {
            e.returnValue = 'Changes you made may not be saved.';
        },
        // async assetRefresh() {
            // const response = await this.loadAsset(this.$route.params.id);
            // this.asset = JSON.parse(JSON.stringify(response));
            // this.tmpAsset = this.asset;
            // this.tmpAsset = 
        // },
        async onComponentInitOrChange() {
            const response = await this.loadAsset(this.$route.params.id);
            const userId = this.$store.getters['user/getUserId'];

            if (response.user_id !== userId) {
                addErrorNotification('You can edit only your own creations');
                this.$router.push({ name: DASHBOARD_PAGE_NAME });
                return;
            }

            this.asset = response;

            if (this.$route.query.step) {
                this.activeStep = this.$route.query.step;
            } else {
                this.activeStep = 'binaryFileAndThumb';
            }
            this.tmpAsset = {...this.serialiseAsset(this.asset)};
        },
    },
    beforeRouteEnter(to, from, next) {
        // check if user logged in, otherwise redirect to home page
        if (!store.getters['user/isLogged']) {
            // router initialize before Notification component, so we should wait for it
            // TODO: fix setTimeout
            setTimeout(() => {
                addInfoNotification('To edit an asset, you must be logged in');
            }, 1500);
            next('/');
            return;
        }
        next();
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name !== from.name) {
            this.onComponentInitOrChange();
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // if redirect was caused by form submit, move further
        if (this.finish) {
            return next();
        }
        next(true);
    },
};
</script>

<style lang="scss" scoped>
.create-asset-footer-next {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    font-size: 1rem;
    position: relative;
    padding: em(20) 0;
    min-height: rem(115);

    @media (max-width: $xl-down) {
        min-height: rem(80);
    }
}
.save-or-next-button {
    display: flex;
    flex-direction: column;
}
.display-none {
    display: none;
}
.return-text {
    margin-left: 1em;
}
.grid {
    max-width: 1200px;
    margin: 77px auto;
}
.active {
    cursor: pointer !important;
}
.inactive {
    cursor: not-allowed !important;
}
.just-save-link {
    text-decoration: underline;
    cursor: pointer;
    padding-top: 1rem;
}
.flex-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}
</style>
